<template>
  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false" :show-top-header="true" buy-button-class="btn-default btn-small">

      <!-- Start Elements Area  -->
      <div class="rwt-gallery-area rn-section-gap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 mb--20">
              <SectionTitle
                  text-align="center"
                  subtitle="YAO XIE GONG MAO"
                  :title="productName"
              />
            </div>
          </div>
          <Gallery :gallery-data="galleryData" column="col-lg-3 col-md-4 col-sm-6 mt--30"/>
        </div>

        <Pagination
            @change="changePage"
            :current="queryParams.pageNum"
            :pageSize="queryParams.pageSize"
            :total="total"
            :hideOnSinglePage="true"
            :showQuickJumper="true"
            :showTotal="true"
            placement="center"
        />
      </div>
      <!-- End Elements Area  -->




    </Layout>
</template>

<script>
    import Layout from "../../components/common/Layout";
    import Separator from "../../components/elements/separator/Separator";
    import AdvancePricing from "../../components/elements/pricing/AdvancePricing";
    import Gallery from '../../components/elements/gallery/Gallery'
    import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
    import Pagination from "../../components/elements/page/Pagination";
    export default {
        name: 'ProductAgency',
        components: {Gallery, AdvancePricing,  Separator, Layout,SectionTitle,Pagination},
        data() {
            return {
              total: 0,
              queryParams: {
                pageNum: 1,
                pageSize: 8,
                navId: this.$route.query.id,
              },


              galleryData: [],
              productName: undefined


            }
        },
        created() {
          this.getProduct(this.queryParams);
        },
        methods:{
          getProduct(data){
            this.getRequest("/system/web/product",data).then(resp=>{
              this.productName = resp.data.msg;
              let galleryList = []
              resp.data.rows.forEach(item =>{
                var fileUrl = item.url;
                let data={
                  id: item.productId,
                  thumb: process.env.VUE_APP_BASE_API+fileUrl,
                  src: process.env.VUE_APP_BASE_API+fileUrl,
                  type: "image",
                  title: item.firstTitle,
                  content: item.remark
                }
                galleryList.push(data)
              })
              this.galleryData = galleryList;
              this.total = resp.data.total;

            })
          },
          changePage(pager){
            this.queryParams.pageNum = pager.page;
            this.queryParams.pageSize = pager.pageSize;
            this.getProduct(this.queryParams);
          }
        }
    }
</script>